module.exports = __webpack_public_path__ + "static/media/instagram.0f5bb670.svg";